import React, { useContext, useEffect, useState } from 'react';
import ConnUrls from '../Connections/ConnectURL';
import myFunctions from '../myFunctions';
import { MasterContext, MobiOrNotContext } from '../ContextApi/context';


///שכבת "תמונת ההמתנה" - משותפת לכל העמודים.
///item: התוצאה של myFunctions.setTheImgWait. ready: העמוד מוכן - מתחילה היציאה (zoomOut אחרי imgDelay).
///noExit: בלי אנימציית יציאה (עמוד החיפוש פשוט מסיר את השכבה).
///הדמות מוצגת מיד (גם תוך כדי ההורדה). הקובץ נטען גם ב-Image נפרד כדי לדעת מתי ירד.
///imgWaitingPicIn / imgWaitingNoPic - App.js מחכה לאחד מהם לפני שמוריד את ה-splash.
///כל עוד העמוד לא קבע תמונה (item בלי active - הנתונים שלו עוד לא הגיעו), התמונה
///נלקחת ממפת תמונות ההמתנה לפי הנתיב (myFunctions.waitPageFromMap). הבחירה האקראית
///נשמרת, ולכן כשהעמוד קובע את התמונה מהנתונים שלו היא אותה תמונה
const WaitImgOverlay = ({ item: pageItem, ready, noExit }) => {
    const [master] = useContext(MasterContext);
    const [mobiOrNot] = useContext(MobiOrNotContext);
    const [, setMapTick] = useState(0);

    useEffect(() => myFunctions.onWaitMapReady(() => setMapTick(t => t + 1)), []);

    let item = pageItem;
    if (master && (!pageItem || pageItem.active === undefined)) {
        const fromMap = myFunctions.waitPageFromMap();
        if (fromMap) item = myFunctions.setTheImgWait(fromMap, master, mobiOrNot);
    }

    const url = item?.waitImg ? `${ConnUrls.media(item.waitImg)}` : "";
    const [loadedUrl, setLoadedUrl] = useState("");

    useEffect(() => {
        if (!url || loadedUrl === url) return;
        let alive = true;
        myFunctions.preloadWaitImg(url, () => { if (alive) setLoadedUrl(url) });
        return () => { alive = false };
    }, [url]);

    if (item?.active === false) return null;

    let outCss = (ready && !noExit) ?
        `imgWaiting animate__animated animate__fast animate__zoomOut ${item?.imgDelay || ''} ${item?.imgWaitingSpecial || ''}`
        : "imgWaiting";

    //כבר בזיכרון (טעינה מוקדמת / ה-splash / עמוד קודם)
    let cached = myFunctions.waitImgLoaded(url);
    let picCss = !url ? (item?.active ? "imgWaitingNoPic" : "")
        : (loadedUrl === url || cached) ? "imgWaitingPicIn" : "";

    return (
        <div className={outCss}>
            <div className={`imgWaitingPic ${picCss}`}
                style={{
                    backgroundImage: url ? `url(${url})` : 'none',
                    backgroundPosition: item?.imgBackPos || 'center',
                    backgroundSize: item?.backgroundSize || 'contain',
                    backgroundRepeat: item?.backgroundRepeat || 'no-repeat'
                }} />
        </div>
    )
}

export default WaitImgOverlay;
